exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inline.alert{color:#777}.inline.alert .icon{color:red}.inline.warning{color:#777}.inline.warning .icon{color:orange}.inline.warning .button{margin:0 6px}.inline.success .icon{color:green}", ""]);

